/*
 *
 * !!! IMPORTANT !!!
 *
 * If you make a change to this file, run "yarn docs" to update the corresponding readme file
 *
 * NOTE: This file uses CommonJS exports rather than ES6 because this file is used in a Node script scripts/update-embedding-docs.mjs
 * Files within the src/ directory can still import using ES6 because webpack will treat all files withing src/ as ES6 modules
 */

module.exports.emittedMessages = {
  init: {
    type: 'init',
    description: 'App has mounted and is ready for communication',
  },
  urlChange: {
    type: 'urlChange',
    description:
      'The client side router is changed. Only the pathname, query params and hash are sent. The protocol and domain are omitted.',
    payloadShape: '{ url: string, redirectedFrom?: string }',
  },
  tokenInvalid: {
    type: 'tokenInvalid',
    description:
      'The integration token was rejected by the backend API. It needs to be updated in order to successfully make requests.',
  },
};

module.exports.consumedMessages = {
  routerPush: {
    type: 'routerPush',
    description: 'Uses client side routing to navigate to a new path.',
    payloadShape: 'string | { pathname: string, search?: string, hash?: string }',
  },
  routerPop: {
    type: 'routerPop',
    description: 'Uses client side routing to navigate backwards in the history stack',
  },
  updateToken: {
    type: 'updateToken',
    description: 'Replaces the currently stored token with a new one.',
    payloadShape: '{ token: UUIDString }',
  },
};
